/*
 * @Description: 
 * @Author: -898-
 * @Date: 2024-05-24 17:12:36
 * @LastEditTime: 2025-02-24 17:21:14
 * @LastEditors: -898-
 */
import Preview from '@/components/CtPreview/Preview'
import { getToken } from "@/utils/auth";
import Vue from 'vue'

let PreviewConstruct = Vue.extend(Preview)
const preview = function (params) {
  let filename = params.name
  let ext = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase()
  if (ext === 'pdf') {
    if (getToken()) {
      window.open(process.env.VUE_APP_BASE_API + 'file/pri/preview?fileId=' + params.fileId, '_blank')
      return
    } else {
      window.open(process.env.VUE_APP_BASE_API + 'file/pub/preview?fileId=' + params.fileId, '_blank')
      return
    }

  }
  // let previewDom = new PreviewConstruct({
  //   data: {
  //     file: params
  //   }
  // })
  // document.body.appendChild(previewDom.$mount().$el)
  if (ext === 'png' || ext === 'jpeg' || ext === 'jpg') {
    let previewDom = new PreviewConstruct({
      data: {
        file: params
      }
    })
    document.body.appendChild(previewDom.$mount().$el)
    return
  }
  let fileData = params.name.split(".");
  if (getToken()) {
    this.download(
      "/file/pri/download",
      {
        fileId: params.fileId,
      },
      `${fileData[0]}_${new Date().getTime()}.${ext}`
    );
  } else {
    this.download(
      "/file/pub/download",
      {
        fileId: params.fileId,
      },
      `${fileData[0]}_${new Date().getTime()}.${ext}`
    );
  }

}
export default preview

